//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiClose, mdiQrcodeScan, mdiContentCopy } from '@mdi/js'
import copy from 'clipboard-copy'
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    QrcodeVue,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      link: 'https://www.bluconsole.com/qr-report?url-link=',
      size: 300,
      icons: {
        mdiClose,
        mdiQrcodeScan,
        mdiContentCopy,
      },
      dialog: false,
    }
  },
  methods: {
    copyItem(item) {
      copy(item)
      this.$dialog.message.success(this.$t('Copied link to clipboard'))
    },
  },
}
